var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M284.87 447.85C284.87 496.12 244.03 535.32 193.74 535.32C143.44 535.32 102.6 496.12 102.6 447.85C102.6 399.57 143.44 360.38 193.74 360.38C244.03 360.38 284.87 399.57 284.87 447.85Z",
    id: "a1M5KAzH5j"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.01 0C480.01 0 160 0 120 0C86.95 0 58.68 11.74 35.21 35.21C11.74 58.68 0 86.95 0 120C0 160 0 480 0 520C0 553.05 11.74 581.32 35.21 604.79C58.68 628.26 86.95 640 120 640C160 640 480.01 640 520.01 640C553.06 640 581.33 628.26 604.79 604.79C628.26 581.32 640 553.05 640 520C640 480 640 160 640 120C640 86.95 628.26 58.67 604.79 35.21C581.33 11.74 553.06 0 520.01 0Z",
    id: "ak7xDDdYS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87 197.5C284.87 245.78 244.03 284.97 193.74 284.97C143.44 284.97 102.6 245.78 102.6 197.5C102.6 149.22 143.44 110.03 193.74 110.03C244.03 110.03 284.87 149.22 284.87 197.5Z",
    id: "h4s7ssf3R0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87 430.75C284.87 479.03 244.03 518.23 193.74 518.23C143.44 518.23 102.6 479.03 102.6 430.75C102.6 382.48 143.44 343.28 193.74 343.28C244.03 343.28 284.87 382.48 284.87 430.75Z",
    id: "a1ISjZgyj"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1M5KAzH5j",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak7xDDdYS",
    opacity: 1,
    fill: "#3F67F6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak7xDDdYS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h4s7ssf3R0",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1ISjZgyj",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.59a43e2539315ec95cc742117e6534c4.svg";
export { ForwardRef as ReactComponent };